
import SampleItem  from './sample-item.vue'
export default {
  components: {SampleItem},
  props: {
    mode: {
      type: String,
      required: true
    },
    file: {
      type: Object,
      required: true
    },
  },
  emits: ['delete', 'download']
}
